export async function download(url: string) {
  const a = document.createElement('a');
  a.href = await toDataURL(url);
  a.download = '';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

function toDataURL(url: string) {
  return fetch(url + '?cors=1').then((response) => {
    return response.blob();
  }).then(blob => {
    const urlCreator = window.URL || window.webkitURL;
    return urlCreator.createObjectURL(blob);
  });
}
